export const VideoIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.15 6.67C20.74 6.45 19.88 6.22 18.71 7.04L17.24 8.08C17.13 4.97 15.78 3.75 12.5 3.75H6.5C3.08 3.75 1.75 5.08 1.75 8.5V16.5C1.75 18.8 3 21.25 6.5 21.25H12.5C15.78 21.25 17.13 20.03 17.24 16.92L18.71 17.96C19.33 18.4 19.87 18.54 20.3 18.54C20.67 18.54 20.96 18.43 21.15 18.33C21.56 18.12 22.25 17.55 22.25 16.12V8.88C22.25 7.45 21.56 6.88 21.15 6.67ZM11 11.88C9.97 11.88 9.12 11.04 9.12 10C9.12 8.96 9.97 8.12 11 8.12C12.03 8.12 12.88 8.96 12.88 10C12.88 11.04 12.03 11.88 11 11.88Z"
      fill="white"
    />
  </svg>
);

export const VideoIconOutlined = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_13492_18413)">
      <path
        d="M10.5703 29.2656H22.8164C25.6758 29.2656 27.3867 27.6016 27.3867 24.7422V14.5117C27.3867 11.6641 25.6758 10 22.8164 10H10.5703C7.83984 10 6 11.6641 6 14.5117V24.7422C6 27.6016 7.71094 29.2656 10.5703 29.2656ZM10.8984 27.4961C8.97656 27.4961 7.88672 26.5 7.88672 24.4727V14.793C7.88672 12.7539 8.97656 11.7578 10.8984 11.7578H22.4883C24.3984 11.7578 25.5 12.7539 25.5 14.793V24.4727C25.5 26.5 24.3984 27.4961 22.4883 27.4961H10.8984ZM27.1172 16.3516V18.5781L32.6953 13.9727C32.8008 13.8906 32.8711 13.832 32.9766 13.832C33.1172 13.832 33.1758 13.9492 33.1758 14.1133V25.1523C33.1758 25.3164 33.1172 25.4219 32.9766 25.4219C32.8711 25.4219 32.8008 25.3633 32.6953 25.293L27.1172 20.6875V22.9023L31.8164 26.8867C32.2852 27.2734 32.8008 27.543 33.2812 27.543C34.3125 27.543 34.9922 26.7812 34.9922 25.6914V13.5742C34.9922 12.4844 34.3125 11.7227 33.2812 11.7227C32.8008 11.7227 32.2852 11.9922 31.8164 12.3789L27.1172 16.3516Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13492_18413">
        <rect width="28.9922" height="19.2773" fill="white" transform="translate(6 10)" />
      </clipPath>
    </defs>
  </svg>
);
